import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {
  Heading,
  P,
  SectionFooterHeading,
  SectionSmallHeading,
  SectionSubHeading,
} from "../../../Styles/style";
import whitelogo from "../../../../assets/images/logo.png";
import Telegram from "../../../../assets/images/telegram.png";
import Twitter from "../../../../assets/images/twitter.png";
import Medium from "../../../../assets/images/medium.png";
import { useTheme } from "@emotion/react";

const EmailInput = styled.input`
  width: 100%;
  max-width: 400px;
  padding: 10px 20px;
  border-radius: 100px;
  border: none;
`;

const BlueBtn = styled.a`
  padding: 9px 15px;
  border-radius: 20px;
  background-color: #0365f5;
  font-family: "Poppins-SemiBold";
  color: #fff;
  margin-left: 20px;
`;
const SectionWrapper = styled.div`
  background-color: ${(props) => props.theme.bgTertiary};
  position: relative;
  display: flex;
  align-items: center;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "30px 0")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`;

const SocialsDiv = styled.div`
  display: grid;
  padding: 10px 0 20px 0;
`;
const SocialLinks = styled.a`
  color: ${(props) => (props.colors ? props.colors : props.theme.textPrimary)};
  font-family: "Poppins-Regular";
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 7px 0;
`;

const SectionFooterWrapper = styled.div`
  background-color: ${(props) => props.theme.bgQuaternary};
  padding: 60px 0;
`;
const GridBorder = styled(Grid)`
  padding: 10px 0;
  @media screen and (max-width: 599px) {
  }
`;
const GridDesktop = styled(Grid)``;
const ImgLogg = styled.img`
  width: 100%;
  max-width: 140px;
`;

const S9_Footer = () => {
  const theme = useTheme();
  return (
    <div>
      <SectionFooterWrapper>
        <Container maxWidth="xl">
          <GridBorder container>
            <Grid
              item
              xs={12}
              md={4}
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-easing="ease-in"
              data-aos-offset="0"
            >
              <ImgLogg src={whitelogo} />
              <P maxWidth="70%" align599="center">
                Transforming Digital Transactions with Unrivaled Privacy.
              </P>
              <P p="30px 0 0" maxWidth="70%" align599="center">
              Copyright © Incognito Wallet 2022. All rights reserved.
              </P>
            </Grid> 
            <Grid item xs={12} md={2} />

            <Grid
              item
              xs={12}
              md={2}
              data-aos="fade-up"
              data-aos-delay="500"
              data-aos-duration="1000"
              data-aos-easing="ease-in"
              data-aos-offset="0"
            >
              <SectionFooterHeading>Legal</SectionFooterHeading>
              <SocialsDiv>
                <SocialLinks href="/#privacypolicy">Privacy Policy</SocialLinks>
                <SocialLinks href="/#terms&conditions">
                  Terms & Conditions
                </SocialLinks>
                <SocialLinks href="/#wallettermsofuse">
                  Wallet Terms of Use
                </SocialLinks>
                <SocialLinks href="/#securityaudits">
                  Security Audits
                </SocialLinks>
              </SocialsDiv>
            </Grid>
            <GridDesktop
              item
              xs={12}
              md={2}
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="700"
              data-aos-easing="ease-in"
              data-aos-offset="0"
            >
              <SectionFooterHeading>Socials</SectionFooterHeading>
              <SocialsDiv>
                <SocialLinks href="#" target="_blank">
                  {" "}
                  Twitter
                </SocialLinks>
                <SocialLinks href="#" target="_blank">
                  {" "}
                  Telegram
                </SocialLinks>
                <SocialLinks href="#" target="_blank">
                  {" "}
                  Medium
                </SocialLinks>
                <SocialLinks href="#" target="_blank">
                  {" "}
                  Github
                </SocialLinks>
                <SocialLinks href="#" target="_blank">
                  LinkedIn
                </SocialLinks>
              </SocialsDiv>
            </GridDesktop>
            <Grid
              item
              xs={12}
              md={2}
              data-aos="fade-up"
              data-aos-delay="900"
              data-aos-duration="1000"
              data-aos-easing="ease-in"
              data-aos-offset="0"
            >
              <SectionFooterHeading>Get In Touch</SectionFooterHeading>
              <SocialsDiv>
                <SocialLinks href="#">info@incognito.com</SocialLinks>
                <SocialLinks href="/#contactsupport">
                  Contact Support
                </SocialLinks>
              </SocialsDiv>
            </Grid>
          </GridBorder>
        </Container>
      </SectionFooterWrapper>
    </div>
  );
};

export default S9_Footer;
